import { render, staticRenderFns } from "./NotificationsPanel.vue?vue&type=template&id=6b7aac48&scoped=true"
import script from "./NotificationsPanel.vue?vue&type=script&lang=js"
export * from "./NotificationsPanel.vue?vue&type=script&lang=js"
import style0 from "./NotificationsPanel.vue?vue&type=style&index=0&id=6b7aac48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7aac48",
  null
  
)

export default component.exports